<h1 mat-dialog-title>Insert new question for test</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #editForm="ngForm">
      <input type="hidden" [ngModel]="data.id" name="id">
    <div fxLayout="column">
        <mat-form-field appearance="none" fxFlex="60%">
            <mat-label>Text</mat-label>
            <textarea matInput [ngModel]="data.text" name="text"></textarea>
        </mat-form-field>
        <mat-form-field appearance="none" fxFlex="60%">
            <mat-label>Points</mat-label>
            <input matInput number [ngModel]="data.points" name="points">
        </mat-form-field>
        <mat-form-field appearance="none" fxFlex="60%">
            <mat-label>Type</mat-label>
            <mat-select [ngModel]='data.type' name='type'>
                <mat-option value="1">ONE CORRECT ANSWER</mat-option>
                <mat-option value="2">MORE THAN ONE CORRECT ANSWER</mat-option>
                <mat-option value="3">TEXT ANSWER</mat-option>
            </mat-select>
        </mat-form-field>
       
        <!-- <div *ngIf='typeOfQuestion===1'  fxFlex="80%">
            <mat-form-field appearance="fill" >
                <mat-label>Enter the answer</mat-label>
                <input type="text" matInput>
            </mat-form-field>
            <mat-radio-group aria-label="Select correct answer" style="margin-left: 1vw;"> 
                <mat-radio-button value="1" [checked]="true">Correct</mat-radio-button> 
            </mat-radio-group>
            <mat-form-field appearance="fill" >
                <mat-label>Enter the answer</mat-label>
                <input type="text" matInput>
            </mat-form-field>
            <mat-radio-group aria-label="Select correct answer" style="margin-left: 1vw;"> 
                <mat-radio-button value="1">Correct</mat-radio-button> 
            </mat-radio-group>
        </div> -->
        <div mat-dialog-actions>
            <button mat-button (click)="onNoClick()" type="button">No Thanks</button>
            <button class="btn" cdkFocusInitial type="submit">Edit</button>
        </div>
    </div>
  </form>
</div>


